import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["main", "dateDropdown", "dateInput", "dateList", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--tax-returns--entities--dates`
  }

  changeDate(ev) {
    if (ev.target.classList.contains("li-selector")) {
      var id = ev.target.dataset.id
      this.setTaxReturnDate(id)
    }
  }

  setTaxReturnDate(id) {
    var findElement = false
    this.application.dates.forEach(element => {
      if (element.id == id) {
        findElement = true
        this.application.current_date = element
        if (this.application.current_date.open == false) {
          this.application.current_date.message = `A Competência está fechada`
        }
      }
    });

    if (findElement == false) {
      this.application.current_date = { open: false, not_defined: true, message: `A Competência está fechada` }
    }
    this.cleanTaxReturnForms()
    this.runDashboardHtml()
    this.runIncomesHtml()
    this.runPaymentsHtml()
    this.runDocumentsHtml()
    this.runAchievementsHtml()
    this.runMembersHtml()
    this.getControllerByIdentifier("operations--products--tax-returns--entities--show").doSubtitle()
  }

  cleanTaxReturnForms() {
    if (this.getControllerByIdentifier("operations--products--tax-returns--incomes--save")) {
      this.getControllerByIdentifier("operations--products--tax-returns--incomes--save").cancelSave()
    }
  }

  runDashboardHtml() {
    if (this.getControllerByIdentifier("operations--products--tax-returns--entities--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--tax-returns--entities--dashboard").reconnect()
    }
  }

  runIncomesHtml() {
    if (this.getControllerByIdentifier("operations--products--tax-returns--incomes--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--tax-returns--incomes--dashboard").doIncomesDashboard()
    }
  }

  runPaymentsHtml() {
    if (this.getControllerByIdentifier("operations--products--tax-returns--payments--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--tax-returns--payments--dashboard").doPaymentsDashboard()
    }
  }

  runDocumentsHtml() {
    if (this.getControllerByIdentifier("operations--products--tax-returns--documents--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--tax-returns--documents--dashboard").doDocumentsDashboard()
    }
  }

  runAchievementsHtml() {
    if (this.getControllerByIdentifier("operations--products--tax-returns--achievements--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--tax-returns--achievements--dashboard").doAchievementsDashboard()
    }
  }

  runMembersHtml() {
    if (this.getControllerByIdentifier("operations--products--tax-returns--settings--dashboard").hasMainDashboardTarget) {
      this.getControllerByIdentifier("operations--products--tax-returns--settings--members").doMembersListHtml()
    }
  }

  doCalendarHTML() {
    var date = new Date()
    var html = `<div class="form-group">
                  <div class="floating-label floating-label-sm">
                    <label>Competência</label>
                    <div class="dropdown dropdown-selector dropdown-valid-selector" data-${this.controllerName}-target="dateDropdown">
                      <button class="dropdown-toggle form-control d-flex" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="height:32px;"><span class="mr-auto w-100 selected-item" id="selected" data-${this.controllerName}-target="dateInput"></span></button>
                      <div class="dropdown-menu dropdown-menu-selector w-100 box-shadow-selector">
                        <input class="form-control form-control-selector dropdown-search-input" type="text" placeholder="Buscar ...">
                        <ul class="ul-select" data-${this.controllerName}-target="dateList"></ul>
                      </div>
                    </div>
                  </div>`
    var controller = this
    new Promise(function (resolve) {
      resolve(controller.mainTarget.innerHTML = html)
    }).then(() => {
      controller.dateDropdownTarget.value = `Ano ${date.getFullYear()}`
      controller.dateInputTarget.innerText = controller.application.current_date.name
      controller.doDateList()
      controller.getControllerByIdentifier("app--helpers--forms").floatingLabel()
    }) 
    selector()
  }

  doDateList() {
    var listHtml = ``
    this.application.dates.forEach(element => {
      listHtml += `<li data-year="${element.year}" data-id="${element.id}" data-action="click->${this.controllerName}#changeDate" class="li-selector dark">${element.name}</li>`
    });
    this.dateListTarget.innerHTML = listHtml
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

}
